module.exports = __webpack_public_path__ + "site/img/15.22448411.jpg";